import moment from "moment"
import { Timestamp } from "helpers/types/dates"

export function formatTimestamp(timestamp: Timestamp | null | undefined): string {
  if (timestamp == null) {
    return "--"
  }

  return moment(timestamp).format("LTS")
}

export function formatPrice(price: string): string {
  const num = parseFloat(price)
  if (isNaN(num)) return price
  return num.toFixed(2)
}

type ChangeDirection = "positive" | "negative" | "neutral"

export function getChangeDirection(change: number | null | undefined): ChangeDirection {
  if (change == null || change === 0) {
    return "neutral"
  }
  return change > 0 ? "positive" : "negative"
}

export function calculateDollarChange(price: number, changePercent: number): number {
  if (changePercent === -100) return -price
  return price * changePercent / (100 + changePercent)
}

export function formatSignedPrice(value: number): string {
  const sign = value > 0 ? "+" : ""
  return `${sign}${value.toFixed(2)}`
}
